var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video-player-container"},[_c('video',{ref:"videoRef",staticClass:"video-content",attrs:{"src":_vm.videoUrl,"controls":"","autoplay":"","controlslist":"nodownload","playsinline":""},on:{"ended":_vm.playEnd}})])
}
var staticRenderFns = []

export { render, staticRenderFns }